export default __webpack_public_path__ + "static/media/Coyotes.3775b80f.png";